import { ga } from "client/utils/adsense/ga";
import { gtag } from "client/utils/adsense/gtag";
import { FixedEditorLayout } from "components/modules/Layout/FixedEditorLayout/FixedEditorLayout";
import { EditorNavbar } from "components/modules/Navigation/EditorNavbar/EditorNavbar";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAppSelector } from "store/store";
import { BottomMenu } from "./BottomMenu/BottomMenu";
import { ResizeSettings } from "./EditSettings/ResizeSettings/ResizeSettings";
import { Preview } from "./Preview/Preview";

export const Enlarger = () => {
    const fromEditor = useAppSelector((state) => state.enlarge.fromEditor);
    const router = useRouter();

    const handleEditorLoadedAnalytics = () => {
        ga("send", {
            hitType: "pageview",
            page: "/vp/image_enlarger/image_loaded/",
            title: "Image Enlarger Image Selected",
        });

        ///event
        gtag("event", "Editor Loaded", {
            event_category: "Image Enlarger",
            event_label: "Editor Page",
        });
    };

    useEffect(() => {
        if (!fromEditor) {
            router.replace("/image-enlarger");
            return;
        }
        handleEditorLoadedAnalytics();
    }, []);

    return (
        <FixedEditorLayout
            navbar={<EditorNavbar actionButton={null} url={"/image-enlarger/editor"} />}
            action={{ desktop: null }}
            bottomMenu={<BottomMenu />}
            controlBar={null}
            preview={<Preview />}
          leftBar={<ResizeSettings />}
        />
    );
};
